/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Mtt_Published_UnknownInputs */

const vi_einvoice_mtt_published_unknown = /** @type {(inputs: Einvoice_Mtt_Published_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phát hành · Chưa xác nhận trạng thái tiếp nhận của CQT`)
};

/**

* @param {Einvoice_Mtt_Published_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_mtt_published_unknown = /** @type {((inputs?: Einvoice_Mtt_Published_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Mtt_Published_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_mtt_published_unknown(inputs)
});